var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
import { defaultProps } from './defaults';
import { DivTag, UlTag, LiTag } from '../../Utils/AtomicTag';
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card(props) {
        return _super.call(this, props) || this;
    }
    Card.prototype.coverRender = function () {
        var cover = this.props.cover;
        if (!cover)
            return null;
        return React.createElement(DivTag, { atomics: [] }, typeof cover == 'string' ? React.createElement("img", { src: cover }) : cover);
    };
    Card.prototype.actionRender = function () {
        var actions = this.props.actions;
        var actionsCls = [
            'border-t',
            'border-solid',
            'border-gray-400',
            'flex',
            'items-center',
            'content-between',
        ];
        var actionsItemCls = [
            'flex',
            'items-center',
            'justify-center',
            'my-3',
            'flex-grow',
            'cursor-pointer',
            'hover:text-brand-600',
        ];
        var actionsItemBorderCls = [
            'border-r',
            'border-solid',
            'border-gray-400',
            'last:border-0',
        ];
        if (actions.length == 0)
            return null;
        return (React.createElement(UlTag, { atomics: actionsCls }, actions.map(function (item, index) {
            return (React.createElement(LiTag, { key: index, atomics: __spread(actionsItemCls, actionsItemBorderCls) }, item));
        })));
    };
    Card.prototype.loadingRender = function () {
        var loadingRowCls = ['flex'];
        var loadingBlockCls = [
            'h-6',
            'w-full',
            'rounded-sm',
            'my-px-4',
            'bg-gray-100',
        ];
        return (React.createElement(DivTag, { atomics: ['p-6'] },
            React.createElement(DivTag, { atomics: loadingRowCls },
                React.createElement(DivTag, { atomics: loadingBlockCls, style: { width: '100%' } })),
            React.createElement(DivTag, { atomics: loadingRowCls },
                React.createElement(DivTag, { atomics: loadingBlockCls, style: { width: '100%' } })),
            React.createElement(DivTag, { atomics: loadingRowCls },
                React.createElement(DivTag, { atomics: loadingBlockCls, style: { width: '100%' } })),
            React.createElement(DivTag, { atomics: loadingRowCls },
                React.createElement(DivTag, { atomics: loadingBlockCls, style: { width: '100%' } }))));
    };
    Card.prototype.render = function () {
        var _a = this.props, title = _a.title, extra = _a.extra, children = _a.children, loading = _a.loading, shadow = _a.shadow, bordered = _a.bordered, rest = __rest(_a, ["title", "extra", "children", "loading", "shadow", "bordered"]);
        var cardCls = ['text-sm', 'h-full', 'bg-white', 'rounded-md'];
        var cardHeadCls = [
            'border-b',
            'border-solid',
            'border-gray-400',
            'min-h-px-48',
            'px-px-24',
        ];
        var cardHeadWrapperCls = ['flex', 'items-center'];
        var cardHeadTitleCls = ['flex-1', 'py-4', 'truncate', 'text-base'];
        var cardHeadExtraCls = ['float-right', 'py-4', 'text-sm'];
        var cardContentCls = ['p-6'];
        if (bordered)
            cardCls.push('border', 'border-solid', 'border-gray-300');
        if (shadow == 'always') {
            cardCls.push('shadow-md');
        }
        else if (shadow == 'hover') {
            cardCls.push('hover:shadow-md', 'hover:border-opacity-0');
        }
        return (React.createElement(DivTag, __assign({ name: Card.NAME, atomics: cardCls }, rest),
            (title || extra) && (React.createElement(DivTag, { atomics: cardHeadCls },
                React.createElement(DivTag, { atomics: cardHeadWrapperCls },
                    React.createElement(DivTag, { atomics: cardHeadTitleCls }, title),
                    extra && React.createElement(DivTag, { atomics: cardHeadExtraCls }, extra)))),
            this.coverRender(),
            loading ? this.loadingRender() : React.createElement(DivTag, { atomics: cardContentCls }, children),
            this.actionRender()));
    };
    Card.defaultProps = defaultProps;
    Card.NAME = 'card';
    Card.displayName = 'Card';
    return Card;
}(React.PureComponent));
export { Card };
